import React from "react";

import "./Intro.css";

const videos = [
  { id: "p0oOsYdOxHw", type: "video" },
  { id: "u3-XT2QFi1I", type: "short" },
  { id: "lTQ-AUk9-o4", type: "short" },
  { id: "peSVS4IqkwM", type: "video" },
  { id: "7MalEueKJww", type: "short" },
];

const Intro = () => {
  return (
    <div className="videos">
      {videos.map(({ id, type }) => (
        <div
          key={id}
          className={`app__video ${type === "short" ? "app__video--short" : ""}`}
        >
          <iframe
            src={`https://www.youtube.com/embed/${id}`}
            title="YouTube video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      ))}
    </div>
  );
};

export default Intro;
